// A closed engagement is a record: its card is greyed out and says so (QA #16). The server already
// refuses edits and offers no actions; this makes that visible instead of leaving the user guessing.
export const closedCardClass = (closed: boolean): string => (closed ? 'grayscale opacity-70' : '');

export const CLOSED_CARD_NOTICE = 'This job is closed — view only. No actions are available.';
